
import router from '../router'
import dayjs from "dayjs";
import departmentApi from './api/department';
import { useDepartmentStore } from "@/stores";
import {
    showToast,
    showLoadingToast,
    showSuccessToast,
    showFailToast,
    showDialog,
} from "vant";
// 通过status 设置样式，status为1 待开始，20 进行中，30 已结束 40 已取消
export const setStatusStyle = (status) => {
    let style = {};
    switch (status) {
        case 1:
            style = {
                className: 'status_waiting',
                statusText: '待开始'
            };
            break;
        case 20:
            style = {
                className: 'status_ongoing',
                statusText: '进行中'
            };
            break;
        case 30:
            style = {
                className: 'status_ended',
                statusText: '已结束'
            };
            break;
        case 40:
            style = {
                className: 'status_canceled',
                statusText: '已取消'
            };
            break;
        default:
            style = {
                className: 'status_ongoing',
                statusText: '进行中'
            }
            break;
    }
    return style;
}
// 获取时间段内的近3天
export const getPreviousThreeDays = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const today = new Date(); // 当前日期
    startDate.setHours(0, 0, 0, 0); // 将开始时间设置为0点
    endDate.setHours(0, 0, 0, 0); // 将结束时间设置为0点
    today.setHours(0, 0, 0, 0); // 将当前时间设置为今天的0点

    // 用于存储结果的日期数组
    const previousDays = [];
    // 当前时间小于开始时间，还未开始
    if (today < startDate) {
        return previousDays;
    }
    // 当前时间大于开始时间且小于等于结束时间 进行中
    if (today >= startDate && today <= endDate) {
        previousDays.push(dayjs(today).format('YYYY-MM-DD'));
        let daysNum = Math.floor((today - startDate) / (24 * 60 * 60 * 1000));
        // daysNum = daysNum > 3 ? 3 : daysNum;
        for (let i = 1; i < daysNum + 1; i++) {
            today.setDate(today.getDate() - 1);
            if (today >= startDate) { // 确保日期不小于开始时间
                previousDays.push(dayjs(today).format('YYYY-MM-DD'));
            }
        }
    }
    // 当前时间大于结束时间 已结束
    if (today > endDate) {
        previousDays.push(dayjs(endDate).format('YYYY-MM-DD'));
        let daysNum = Math.floor((endDate - startDate) / (24 * 60 * 60 * 1000));
        // daysNum = daysNum > 3 ? 3 : daysNum;
        for (let i = 0; i < daysNum; i++) {
            endDate.setDate(endDate.getDate() - 1);
            if (endDate <= today) { // 确保日期不大于今天
                previousDays.push(dayjs(endDate).format('YYYY-MM-DD'));
            }
        }
    }
    return previousDays;
}

// 设置签到tag
export const setSignDate = (signDate) => {
    // 1、设置时间tag
    let signtagArr = [];
    signDate?.map((item) => {
        signtagArr.push({
            label: dayjs(item).format('MM/DD'),
            value: item,
        });
    });
    return signtagArr
}

/*
 * 活动、签到、经理端活动、签到 设置默认时间
 * 参数2： startTime： 活动开始时间
 * 参数3： endTime： 活动结束时间
 * 
 * 返回值：{
     start_time： 开始时间时间戳
     end_time： 结束时间 时间戳
     startTime：开始时间 年月日 时分秒
     endTime： 结束时间 年月日 时分秒
 }
*/
export const setDefaultTime = (startTime, endTime) => {
    // 当前时间
    let newDate = dayjs().format('YYYY-MM-DD');
    let newDate_num = new Date().getTime();
    // 近30天时间
    let new_start_time = dayjs().subtract(30, 'days').format('YYYY-MM-DD');
    let new_start_time_num = new Date(new_start_time).getTime();
    // 开始时间
    startTime = dayjs(startTime).format('YYYY-MM-DD');
    let start_time_num = new Date(startTime).getTime();
    // 活动结束时间
    endTime = dayjs(endTime).format('YYYY-MM-DD');
    let end_time_num = new Date(endTime).getTime();
    // 当前时间小于开始时间 活动未开始
    // if(newDate_num < start_time_num) {

    // }
    // 当前时间在范围内
    if (newDate_num > start_time_num && newDate_num <= end_time_num) {
        // 近30天 大于 开始时间 取值开始时间
        if (new_start_time_num > start_time_num) {
            startTime = new_start_time;
            start_time_num = new_start_time_num;
        }
        endTime = newDate;
        end_time_num = newDate_num;
    }
    // 当前时间大于结束时间
    if (newDate_num > end_time_num) {
        startTime = dayjs(endTime).subtract(30, 'days').format('YYYY-MM-DD');
        start_time_num = new Date(startTime).getTime();
    }
    return {
        start_time: start_time_num,
        end_time: end_time_num,
        startTime,
        endTime
    }
}


// 获取当前账号下部门信息
export const getDepartmentListAll = (operableUuids, type = '') => {
    return new Promise(async (resolve, reject) => {
        let departmentListAll = useDepartmentStore().getDepartment('departmentListAll') || [];
        if (!!departmentListAll && departmentListAll.length !== 0 && !type) {
            resolve(departmentListAll);
        }
        let para = {
            uuid: operableUuids
        };
        let res = await departmentApi.getMyDepartment(para);
        if (res.code != 200) {
            showToast({
                message: res.msg,
                duration: 2000
            })
            reject(res.msg)
        }
        if (res.code == 200) {
            resolve(res.data)
        }
    })
}
// 获取分部的部门uuid
export const getFirmRegionDepartment = (uuid) => {
    let req = {
        firm_region_uuid: uuid,
    };
    return new Promise(async (resolve, reject) => {
        let res = await departmentApi.getFirmRegionDepartment(req);
        if (res.code != 200) {
            showToast({
                message: res.msg,
                duration: 2000
            })
            reject(res.msg)
        }
        if (res.code == 200) {
            resolve(res.data)
        }
    })
}
// 获取部门和岗位信息
export const getDeptAndPost = () => {
    return new Promise(async (resolve, reject) => {
        let departmentInfo = useDepartmentStore().getDepartment('departmentInfo');
        if (!!departmentInfo && departmentInfo.length !== 0) {
            resolve(departmentInfo);
        }
        let res = await departmentApi.getDepartmentInfo({});
        if (res.code !== 200) {
            showToast({
                message: res.msg || "网络异常，请重试？",
                duration: 2000
            })
            reject(false);
            return false;
        }
        useDepartmentStore().updateDepartment('departmentInfo', res.data || []);
        resolve(res.data || []);
    });
}

// 设置默认选择部门
export const setDefaultDepartment = (department, type) => {
    let departmentList = useDepartmentStore().getDepartment('departmentInfo');
    if (!departmentList || departmentList.length === 0) {
        return {};
    }
    if (!department || !department.uuid) {
        department = {
            name: departmentList[0]?.department?.name || "",
            uuid: departmentList[0]?.department?.uuid || "",
            type: departmentList[0]?.department?.type || ""
        } || {};
    }
    let data = {
        name: department.name || "",
        uuid: department.uuid || "",
        type: department?.type || ""
    };
    if (type === 'attendance') {
        useDepartmentStore().updateDepartment('attendanceDepartment', data || []);

    }
    if (type === 'group') {

    }
    if (!type) {
        useDepartmentStore().updateDepartment('selDepartmentInfo', data || []);
    }

    return data;
}
// 获取部门下级
export const getDepartmentLowerLevel = (uuid, type = "") => {
    return new Promise(async (resolve, reject) => {
        let allLowerLevel = useDepartmentStore().getDepartment('allLowerLevel')
        if (!!allLowerLevel && allLowerLevel.length !== 0 && !type) {
            resolve(allLowerLevel);
        }
        let para = {
            uuid: uuid
        };
        let res = await departmentApi.getDepartmentLowerLevel(para);
        if (res.code !== 200) {
            showToast({
                message: res.msg || "网络异常，请重试？",
                duration: 2000
            })
            reject(false);
            return false;
        }
        if (res.code == 200) {
            allLowerLevel = getAllLowerLevel(res.data);
            if (!type) {
                useDepartmentStore().updateDepartment('allLowerLevel', allLowerLevel || []);
            }
            resolve(allLowerLevel)
        }
    })
}
export const getAllLowerLevel = (tree) => {
    const uuids = [];

    function traverse(node) {
        if (node.uuid != null) uuids.push(node.uuid); // 收集当前节点uuid
        if (node.children && node.children.length) {
            node.children.forEach(traverse); // 递归遍历子节点
        }
    }

    tree.forEach(traverse);
    return uuids;
}